module.exports = __webpack_public_path__ + "static/media/simulink_logo.e7c208d1.jpg";